module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-3GENNAIO-25-4f4a55414c865ca78e052d140d546911.png";